import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function PoliciesForm({ policy = {}, onUpdate }) {
  const { t } = useTranslation('bots');
  const [disallowedInput, setDisallowedInput] = useState('');
  const [transferInput, setTransferInput] = useState('');

  const updateField = (key, value) => {
    onUpdate(key, value);
  };

  const handleAddDisallowedTopic = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = disallowedInput.replace(/,/g, '').trim();
      if (value) {
        const currentTopics = policy.disallowed_topics || [];
        if (!currentTopics.includes(value)) {
          updateField('disallowed_topics', [...currentTopics, value]);
        }
        setDisallowedInput('');
      }
    }
  };

  const removeDisallowedTopic = (topic) => {
    const currentTopics = policy.disallowed_topics || [];
    updateField('disallowed_topics', currentTopics.filter(t => t !== topic));
  };

  const handleAddTransferTopic = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = transferInput.replace(/,/g, '').trim();
      if (value) {
        const currentTopics = policy.handoff_required_on || [];
        if (!currentTopics.includes(value)) {
          updateField('handoff_required_on', [...currentTopics, value]);
        }
        setTransferInput('');
      }
    }
  };

  const removeTransferTopic = (topic) => {
    const currentTopics = policy.handoff_required_on || [];
    updateField('handoff_required_on', currentTopics.filter(t => t !== topic));
  };

  return (
    <div className="policies-form">
      <div className="policy-section">
        <h3>{t('policies.disallowedTopicsTitle')}</h3>
        <p className="help-text">
          {t('policies.disallowedTopicsDescription')}
        </p>
        <div className="chips-container">
          {(policy.disallowed_topics || []).map((topic, idx) => (
            <div key={idx} className="chip">
              <span>{topic}</span>
              <button
                type="button"
                onClick={() => removeDisallowedTopic(topic)}
                className="chip-remove"
              >
                ×
              </button>
            </div>
          ))}
        </div>
        <input
          type="text"
          value={disallowedInput}
          onChange={(e) => setDisallowedInput(e.target.value)}
          onKeyDown={handleAddDisallowedTopic}
          placeholder={t('policies.topicInputPlaceholder')}
        />
        <small>{t('policies.topicInputHint')}</small>
      </div>

      <div className="policy-section">
        <h3>{t('policies.handoffTitle')}</h3>
        <p className="help-text">
          {t('policies.handoffDescription')}
        </p>
        <div className="chips-container">
          {(policy.handoff_required_on || []).map((topic, idx) => (
            <div key={idx} className="chip">
              <span>{topic}</span>
              <button
                type="button"
                onClick={() => removeTransferTopic(topic)}
                className="chip-remove"
              >
                ×
              </button>
            </div>
          ))}
        </div>
        <input
          type="text"
          value={transferInput}
          onChange={(e) => setTransferInput(e.target.value)}
          onKeyDown={handleAddTransferTopic}
          placeholder={t('policies.topicInputPlaceholder')}
        />
        <small>{t('policies.topicInputHint')}</small>
      </div>

      <style>{`
        .policies-form {
          margin-top: 1.5rem;
        }

        .policy-section {
          margin-bottom: 2rem;
          padding: 1.5rem;
          background: #f7fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .policy-section h3 {
          margin: 0 0 0.75rem 0;
          font-size: 1rem;
          color: #2d3748;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 1rem;
          cursor: pointer;
          padding: 0.5rem 0;
        }

        .checkbox-label input[type="checkbox"] {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        .policy-section label {
          display: block;
          font-weight: 500;
          color: #2d3748;
          margin-bottom: 0.5rem;
        }

        .policy-section input[type="text"],
        .policy-section input[type="number"] {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #cbd5e0;
          border-radius: 6px;
          font-size: 1rem;
          margin-top: 0.5rem;
        }

        .policy-section input:focus {
          outline: none;
          border-color: #667eea;
        }

        .help-text {
          font-size: 0.875rem;
          color: #718096;
          margin: 0.5rem 0;
        }

        .policy-section small {
          display: block;
          font-size: 0.8rem;
          color: #a0aec0;
          margin-top: 0.25rem;
        }

        .chips-container {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin: 0.75rem 0;
          min-height: 36px;
          padding: 0.5rem;
          background: white;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
        }

        .chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.375rem 0.75rem;
          background: #667eea;
          color: white;
          border-radius: 16px;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .chip-remove {
          background: transparent;
          border: none;
          color: white;
          font-size: 1.25rem;
          line-height: 1;
          cursor: pointer;
          padding: 0;
          margin-left: 0.25rem;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background-color 0.2s;
        }

        .chip-remove:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      `}</style>
    </div>
  );
}
